<template>
  <div class="table-grid">
    <h2 class="c-white pl-10">{{ title }}</h2>
    <ion-grid :scroll-x="true" class="option-row ml-10 mr-10" nowrap>
      <div :style="styleGridTemplateColumns(`4rem 8rem 4rem`, orderedHeaders.length)" class="grid-header">
        <span v-for="(header, headerIndex) in orderedHeaders" :key="headerIndex"> {{ header }}</span>
      </div>
        <div :style="styleGridTemplateColumns(`4rem 8rem 4rem`, row.length)" class="grid-items" v-for="(row, index) in orderedRows" :key="index">
          <span v-for="(item, itemIndex) in row" :key="itemIndex"> {{ getVal(item, row, itemIndex) }}</span>
        </div>
    </ion-grid>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: "TableGrid",
  props: ["match", 'title', 'headers', 'rows', 'items'],
  data() {
    return {
      nationalId : +process.env.VUE_APP_NATIONAL_ID,
    }
  },
  computed: {
    orderedHeaders() {
      if(this.nationalId === 8 || this.nationalId === 12) {
        return this.orderedHeader(this.headers);
      }

      return this.headers;
    },
    orderedRows() {
      if(this.nationalId === 8 || this.nationalId === 12) {
        return this.orderedRow(this.rows);
      }
      return this.rows;
    }
  },
  methods: {
    styleGridTemplateColumns(frontColumns, numColumns) {
      const style = {gridTemplateColumns: `${frontColumns} repeat(${numColumns}, 2.5rem)`};
      return style;
    },
    orderedHeader(header) {
      // G PG YC, 2M, RC and BC
      return [header[0], header[1], header[2], header[3], header[5], header[7], header[4], header[6]];
    },
    orderedRow(rows) {
      // G PG YC, 2M, RC and BC
      for(let i = 0; i < rows.length; i++) {
        rows[i] = [rows[i][0], rows[i][1], rows[i][2], rows[i][3], rows[i][5], rows[i][7], rows[i][4], rows[i][6]];
      }

      return rows;
    },
    getVal(item, row, itemIndex) {
      if (this.nationalId === 8 || this.nationalId === 12) {
        // Goal + Penalty Goal
        return itemIndex === 2 ? row[itemIndex] + row[itemIndex + 1] : item;
      }

      return item;
    }
  }
};
</script>

<style scoped>

.grid-header {
  display: grid;
  gap: 0.5rem;
  /* grid-template-columns: 4rem 8rem 4rem repeat(auto-fill, 4rem); */
  padding: 0.5rem 1.5rem;
  margin-bottom: 1.5rem;
  color: #a9a9a9;
  font-size: 0.8rem;
  font-weight: bold;
  text-overflow: clip;
  white-space: nowrap;
}

.grid-items {
  display: grid;
  gap: 0.5rem;
  /* grid-template-columns: 4rem 8rem 4rem repeat(auto-fill, 4rem); */
  background: #1d1f22;
  padding: 1rem 1.5rem;
  width: 100%;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  line-height: 1rem;
  color: #fff;
  text-overflow: clip;
  white-space: nowrap;
}

.table-grid {
  background: #1d1f22;
  padding: 1rem 1.5rem;
  border-radius: 14px;
  width: 100%;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  line-height: 1rem;
  /* text-align: center; */
  color: #fff;
  /* grid-template-columns: ; */
}

.option-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  border-radius: 1rem;
  background: #1e1f22 !important;
}

</style>
